<template lang="pug">
  .component.component-backoffice-deposit-configuration
    .def(v-if="!value || value.length === 0")
      .row(v-for="elem, index in item.default")
        .column(v-for="val, inx in elem")
          input(type="text", :placeholder="inx", :value="item.default[index][inx]", disabled)
    .row(v-else, v-for="elem, index in value")
      .column.shrink.delete
        DeleteConf(@click="value.splice(index, 1)")
      .column(v-for="val, inx in elem")
        .strategy(v-if="inx === 'strategy'")
          label {{inx}}
            select(v-model="value[index].strategy")
              option(v-for="strategy in strategies") {{strategy}}
        .booking-mode(v-else-if="inx === 'booking_mode'")
          label {{inx}}
            BookingModeSelect(v-model="value[index].booking_mode", :isFilter="true")
          //option(:value="value[index]['booking_mode']") {{value[index]['booking_mode']}}
          //option(:value="value[index]['booking_mode']") FF
        .booking-mode(v-else-if="inx === 'plan'")
          label {{inx}}
            SelectizePlan(:allowEmptyOption="true", :selectedValue="parseInt(value[index].plan)", @optionSelected="setPlan($event,index)",  @optionRemoved="unsetPlan(index)")
        .vehicle-category(v-else-if="inx === 'vehicle_category'")
          label {{inx}}
            SelectizeCategory(:allowEmptyOption="true", :selectedValue="parseInt(value[index].vehicle_category)", @optionSelected="setCategory($event,index)", @optionRemoved="unsetCategory(index)")
        .other-val(v-else)
          label {{inx}}
            input(type="text", :placeholder="inx", v-model="value[index][inx]")
</template>
<script type="text/babel">


  import SelectizePlan from '../../structure/ui/lists/selectize/SelectizePlan'
  import SelectizeCategory from '../../structure/ui/lists/selectize/SelectizeCategory'
  import BookingModeSelect from '../../structure/BookingModeSelect'
  import DeleteConf from './DeleteConf'

  export default {
    name: 'DepositConfiguration',
    components: {DeleteConf, BookingModeSelect, SelectizeCategory, SelectizePlan},
    data() {
      return {
        strategies: ['FIXED', 'ESTIMATE', 'TIME']
      }
    },
    created() {
    },
    methods: {
      setPlan(val, index) {
        this.value[index].plan = val.id
      },
      unsetPlan(index) {
        this.value[index].plan = null
      },
      setCategory(val, index) {
        this.value[index].vehicle_category = val.id
      },
      unsetCategory(index) {
        this.value[index].vehicle_category = null
      },
    },
    computed: {},
    props: ['value', 'item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-backoffice-deposit-configuration
    .input-group
      margin-bottom: 0
    .delete
      display: flex
      align-items: flex-end
</style>



// WEBPACK FOOTER //
// DepositConfiguration.vue?51b5189e